import { createSectionFactory } from "@hydrologiq/shared/createSection"
import Routing from "@hydrologiq/customers/Routing"
import defaultCopy from "./copy"
import { section, graphqlUri, restEndpoint, graphqlUriLegacy } from "./config"
import { TenantProfile } from "@hydrologiq/gql/graphql"
import customerCss from "./index.scss?inline"
import { TenantFeatures } from "@hydrologiq/shared/providers/Features"

const localFeatures: TenantFeatures = {
  customer_reporting: true,
}
const profile = TenantProfile.Rental
// const profile = TenantProfile.FuelProducer

// Create the section using the generic factory
const createSection = createSectionFactory({
  sectionName: "customers",
  section: section,
  RoutingComponent: Routing,
  defaultCopy,
  defaultFeatures: localFeatures,
  graphqlUri,
  restEndpoint,
  primaryGraphqlUri: graphqlUri,
  legacyGraphqlUri: graphqlUriLegacy,
  profile: profile,
  sectionCss: customerCss,
})

export default createSection
